import { computed, defineComponent, ref, onMounted } from 'vue';
import SVG from '@dts/shared/src/assets/svg';
import styles from './index.module.scss';
import { NButton, NDrawer } from 'naive-ui';

import UserCenter from '../../../UserCenter';
import { dashboardApi } from '@/api/modules/dashboard';

const Search = defineComponent({
  setup: () => {
    const showDrawer = ref(false);
    const hasMessage = ref(false);

    const svgDiaplay = computed(() => {
      return hasMessage.value ? <SVG.HeaderUserHasMeeageSVG /> : <SVG.HeaderUserSVG />;
    });

    const handleClick = () => {
      if (showDrawer.value) {
        showDrawer.value = false;
        getHasMessageBoolean();
      } else {
        showDrawer.value = true;
        dashboardApi.recordPageView({
          pageId: 121,
          sourceId: 1,
        });
      }
    };
    const getHasMessageBoolean = async () => {
      try {
        const res = await $dts.dtsUser.newNotification.request({}, {});
        hasMessage.value = res?.data ?? false;
      } catch (err) {
        console.error('newNotification', err);
      }
    };
    const closeDrawer = () => {
      showDrawer.value = false;
      getHasMessageBoolean();
    };
    onMounted(() => {
      getHasMessageBoolean();
    });
    return () => (
      <>
        <NButton
          size="large"
          text
          class={styles.search}
          onClick={handleClick}
          v-slots={{
            icon: () => svgDiaplay.value,
          }}
        ></NButton>

        <NDrawer
          show={showDrawer.value}
          placement="right"
          on-mask-click={closeDrawer}
          default-width="7.04rem"
          show-mask={true}
          zIndex={1200}
          to="#drawer-target"
        >
          <UserCenter showDrawer={showDrawer.value} onUpdate:showDrawer={closeDrawer} />
        </NDrawer>
      </>
    );
  },
});
export default Search;
